import { datadogRum } from "@datadog/browser-rum";
import { isBrowser } from "@fwa/src/utils/browserUtils";
import { checkIfDev, checkIfTest } from "@fwa/src/utils/envUtils";

// this isn't a security risk because its the root package json not this packages so doesn't show package real dependency versions
import pkg from "../../../../package.json";

const ENV_NAME = process.env["NEXT_PUBLIC_ENV_NAME"] || "";
const FWS_BASE_URL = process.env["NEXT_PUBLIC_FWS_BASE_URL"] || "";

const getHostname = (): string => {
  try {
    const url = new URL(FWS_BASE_URL);
    const { hostname } = url;
    return hostname;
  } catch {
    return "";
  }
};

export const setUpDataDog = () => {
  if (checkIfDev() || checkIfTest()) return;

  datadogRum.init({
    applicationId: "bb386083-b4af-4d13-aa40-f09e337fd328",
    clientToken: "pub35186d9874e5d1afd26bf0e8b2cc33c8",
    site: "datadoghq.eu",
    service: "online-fundraising",
    env: ENV_NAME,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: pkg.version,
    sessionReplaySampleRate: 10,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    trackingConsent: "not-granted",

    traceSampleRate: 20,
    allowedTracingUrls: [
      (url) => !!url.length && url.startsWith(getHostname()),
    ],
  });
};

export const enableDataDogTrackingConsent = () => {
  if (checkIfDev() || checkIfTest()) return;
  if (!isBrowser) return;
  datadogRum.setTrackingConsent("granted");
};

export const setDatadogTrackingConsent = (isGranted: boolean) => {
  if (checkIfDev() || checkIfTest()) return;
  if (!isBrowser) return;
  try {
    datadogRum.setTrackingConsent(isGranted ? "granted" : "not-granted");
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // console.error("Error setting DataDog tracking consent:", error);
  }
};

export const trackDataDogError = (err: Error, extraInfo?: object) => {
  if (!isBrowser) return;
  if (checkIfDev() || checkIfTest()) return;
  try {
    datadogRum.addError(err, extraInfo);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // console.error("Error tracking DataDog error:", error);
  }
};
